import { Link } from "react-router-dom";

const UPDATED = "17 September 2026";

/**
 * A starting draft, not a substitute for legal review -- same caveat as
 * Privacy.tsx. Covers what both app stores expect a terms link to cover:
 * who can use the service, how payment/wallet works, cancellation, and
 * liability.
 */
export function Terms() {
  return (
    <div className="mx-auto max-w-2xl px-4 py-12 text-ink-800">
      <Link to="/" className="text-sm font-medium text-brand">
        ← WeShip
      </Link>
      <h1 className="mt-6 text-3xl font-semibold tracking-tight text-ink-900">Terms of Service</h1>
      <p className="mt-1 text-sm text-ink-400">Last updated {UPDATED}</p>

      <div className="prose-sm mt-8 space-y-6 text-[15px] leading-relaxed">
        <p>
          These terms apply to the WeShip web portal and the WeShip mobile app. By creating an
          account or booking a shipment, you agree to them. Questions: <a className="text-brand" href="mailto:support@weship.co.za">support@weship.co.za</a>.
        </p>

        <section>
          <h2 className="text-lg font-semibold text-ink-900">The service</h2>
          <p className="mt-2">
            WeShip arranges courier collection and delivery of parcels within South Africa. We
            quote, book, and track shipments on your behalf through our courier partners; we are
            not the courier ourselves.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-ink-900">Your account</h2>
          <p className="mt-2">
            You're responsible for keeping your login credentials secure and for the accuracy of the
            addresses, parcel details, and declared values you provide — a wrong address or
            understated value can delay a shipment or affect an insurance claim.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-ink-900">Payment and wallet</h2>
          <p className="mt-2">
            Prepaid accounts pay by topping up a wallet balance; invoiced accounts are billed
            separately by agreement. Wallet top-ups are processed by BobPay and only credited once
            the payment is verified — never simply because a payment page redirected back. Top-ups
            are non-refundable except at WeShip's discretion or where required by law.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-ink-900">Prohibited items</h2>
          <p className="mt-2">
            You may not ship anything illegal, dangerous, or prohibited by our courier partners
            (including but not limited to weapons, illegal drugs, and hazardous materials). We may
            refuse or cancel a booking that appears to violate this.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-ink-900">Cancellations</h2>
          <p className="mt-2">
            You can cancel a shipment before collection for a full refund to your wallet. Once a
            parcel has been collected, cancellation is at the courier's discretion and may not be
            possible or refundable.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-ink-900">Liability</h2>
          <p className="mt-2">
            Our liability for loss or damage in transit is limited to the declared value you provide
            and any insurance you purchase at booking. We are not liable for indirect or
            consequential loss.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-ink-900">Changes</h2>
          <p className="mt-2">
            We may update these terms from time to time; the date at the top of this page reflects
            the latest version. Continuing to use WeShip after a change means you accept it.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-ink-900">Privacy</h2>
          <p className="mt-2">
            See our <Link className="text-brand" to="/privacy">Privacy Policy</Link> for how we handle your information.
          </p>
        </section>
      </div>
    </div>
  );
}
